import Vue from 'vue';

// Constants
import { ERROR_MSG } from '@/app/constants/status-constants';

export const addressFinderInterceptor = (instance) => {
	// Interceptors
	instance.interceptors.request.use(config => {
		// Do something before request is sent
		return config;
	}, function (error) {
		// Do something with request error
		return Promise.reject(error);
	})

	instance.interceptors.response.use(response =>  {
		// Do something with response data
		return response;
	}, function (error) {
		// Show timeout error
		if (error.message === ERROR_MSG.TIMEOUT_EXCEEDED) {
			Vue.notify({
				group: 'notifs',
				type: 'error',
				title: ERROR_MSG.INTERNAL_ERROR_TITLE,
				text: ERROR_MSG.INTERNAL_CONNECTION_TIMEOUT,
				duration: -1,
				closeOnClick: true
			});
		}
		// Do something with response error
		return Promise.reject(error);
	})
}